
(function(){
  var s=document.querySelector('.ld-tm'); if(!s) return;
  var t=s.querySelector('[data-ld-track]');
  var p=s.querySelector('[data-ld-prev]'), n=s.querySelector('[data-ld-next]');
  function step(){ var c=t.querySelector('.ld-card'); return c?c.offsetWidth+16:320; }
  var nav=s.querySelector('.ld-nav');
  function state(){
    var max=t.scrollWidth-t.clientWidth-2;
    nav.style.display = max>2 ? '' : 'none';   /* pas de flèches si tout est visible */
    p.disabled=t.scrollLeft<=2;
    n.disabled=t.scrollLeft>=max;
  }
  p.addEventListener('click',function(){ t.scrollBy({left:-step(),behavior:'smooth'}); });
  n.addEventListener('click',function(){ t.scrollBy({left:step(),behavior:'smooth'}); });
  t.addEventListener('scroll',state,{passive:true});
  window.addEventListener('resize',state);
  window.addEventListener('load',state);
  state();
})();
